
import http, { requests } from "./request";

/** 
 * 获取报告列表 
 * @param {*} query
 * @returns
*/

export function getReport(query) {
    return http({
        url: '/zhongjia/guanwang/projectArticle',
        method: 'get',
        params: query,
    })
}

/** 
 * 获取报告详情信息
 * @param {*} query
 *  @returns
 */
export function getReportDetail(id) {
    return http({
        url: '/zhongjia/guanwang/report/' + id,
        method: 'get',
    })
}

/** 获取文章详情 
 * @param {*} query
 * @returns
*/
export function getWebsiteById(params) {
    return http({
        url: '/zhongjia/guanwang/websiteArticle',
        method: 'get',
        params,
    })
}
/**
 * 获取期号列表
 * @param {*} params 
 * @returns 
 */
export function getStageList(params) {
    return http({
        url: '/zhongjia/guanwang/stage',
        method: 'get',
        params,
    })
}
/**
 * 获取项目类目
 * @param {*} params 
 * @returns 
 */
export function getTypeList(params) {
    return http({
        url: '/zhongjia/guanwang/project',
        method: 'get',
        params,
    })
}

/**
 * 获取项目信息
 * @param {*} params 
 * @returns 
 */
export function getDetailProject(id) {
    return http({
        url: '/zhongjia/project/' + id,
        method: 'get',
    })
}
/**
 * 获取点评详情
 * @param {*} params 
 * @returns 
 */
export function getProjectArticleOne(params) {
    return http({
        url: '/zhongjia/guanwang/getProjectArticleOne',
        method: 'get',
        params
    })
}



//3.0 获取项目下指标树
export function getExponentStructure(type, data) {
    const request = requests[type]
    return request({
        url: '/sl-trend-api/openassets/websiteIndicData/getExponentStructure',
        method: 'post',
        data: data,
    })
}
/**
* 获取指标值
* @param {*} query
* @returns
*/
export function getIndicData(type, query) {
    const request = requests[type]
    return request({
        url: "/sl-trend-api/openassets/websiteIndicData/getIndicData",
        method: "post",
        data: query
    })
}